<template>
  <div :class="`${containerClass} grid grid-cols-2 gap-4 mt-4`">
    <div
      v-if="isPhysicalOrMoralPerson"
      class="col-span-2 flex items-center mb-2"
    >
      <input
        id="isForeign"
        v-model="data.isForeign"
        type="checkbox"
        class="mr-2"
        @change="handleForeignToggle"
      >
      <label>Adresse étrangère ?</label>
    </div>

    <div class="col-span-2">
      <t-form-input
        label="Adresse"
        :required="true"
        :error="errors.address"
      >
        <input
          v-model="data.address"
          class="form-control form__input"
          type="text"
          name="address"
          @input="handleChange"
        >
      </t-form-input>
    </div>

    <div class="col-span-1">
      <t-form-input
        label="Code postal"
        :required="true"
        :error="errors.zipCode"
      >
        <input
          v-model="data.zipCode"
          class="form-control form__input"
          type="text"
          name="zipCode"
          @keydown="handleKeyDown"
        >
      </t-form-input>
    </div>

    <div class="col-span-1">
      <t-form-input
        :label="data.isForeign ? 'Ville (et précisez le pays)' : 'Ville'"
        :required="true"
        :error="errors.city"
      >
        <template v-if="data.isForeign">
          <input
            v-model="data.city"
            class="form-control form__input"
            type="text"
            name="city"
            @input="handleChange"
          >
        </template>
        <template v-else>
          <select
            v-model="data.city"
            :disabled="cityOptions.length === 0"
            class="cursor-pointer form-control form__input"
            name="city"
            @change="handleChange"
          >
            <option value="">
              --- Veuillez choisir ---
            </option>
            <option
              v-for="(option, index) in cityOptions"
              :key="`city-options-${index}`"
              :value="option.nom"
            >
              {{ `${data.zipCode} - ${option.nom}` }}
            </option>
          </select>
        </template>
      </t-form-input>
    </div>
  </div>
</template>

<script>
import * as ZipCodeService from '@/services/zipcode';
import { debounce } from 'lodash';

export default {
  name: "AddressInputs",
  props: {
    containerClass: { type: String, required: true },
    errors: { type: Object, required: true },
    addressValues: { type: Object, required: true },
    isPhysicalOrMoralPerson: { type: Boolean, default: false }
  },
  data() {
    return {
      data: {
        zipCode: '',
        city: '',
        address: '',
        isForeign: false
      },
      cityOptions: [],
      isTyping: false,
      onTypingStarted: null,
      onTypingStopped: null
    };
  },
  watch: {
    addressValues(newVal) {
      this.handleRcsAutocomplete(newVal);
    }
  },
  mounted() {
    this.data.address = this.addressValues.address;
    this.data.zipCode = this.addressValues.zipCode;
    this.data.city = this.addressValues.city;
    this.setCity('zipCode');

    this.onTypingStarted = debounce(() => {
        this.isTyping = true;
      }, 500, {
        leading: true,
        trailing: false
    });
    this.onTypingStopped = debounce((event) => {
        this.isTyping = false;
        this.handleChange(event);
      }, 500, {
        leading: false,
        trailing: true
    });
  },
  methods: {
    handleRcsAutocomplete(data) {
      this.data.address = data?.address;
      this.data.zipCode = data?.zipCode;
      this.data.city = data?.city;
      if (data?.zipCode && !this.data.isForeign) this.setCity('zipCode');
    },
    handleChange(event) {
      const { value, name } = event.target;

      if (name === 'zipCode' && !this.data.isForeign) {
        this.setCity(name);
      }

      this.$emit('input', {
        ...this.data,
        [name]: value
      });
    },
    async setCity(name) {
      if (name === 'zipCode' && !this.data.isForeign) {
        this.cityOptions = await ZipCodeService.find(this.data.zipCode);
      }
    },
    handleKeyDown(event) {
      this.onTypingStarted();
      this.onTypingStopped(event);
    },
    handleForeignToggle() {
      if (this.data.isForeign) {
        this.cityOptions = [];
        this.data.city = '';
      } else if (this.data.zipCode) {
        this.setCity('zipCode');
      }
      this.$emit('input', { ...this.data });
    }
  }
};
</script>
